module.exports = __webpack_public_path__ + "static/media/spirit.bb47bb52.png";